import moment from "moment";

export default {
  methods: {
    dateForHuman(date) {
      return moment(date).format("ddd, MMM d, YYYY h:m A");
    },
  },
};
